module.exports = __webpack_public_path__ + "img/street.c83e31c9.png";